import React, { useState } from "react";

// Flashcards with front (Arabic letters) and back (Pronunciation or name of the letter)
const flashcards = [
  { front: "ا", back: "Alif" },
  { front: "ب", back: "Ba" },
  { front: "ت", back: "Ta" },
  { front: "ث", back: "Tha" },
  // Add more as needed...
];

function FlashcardsPage() {
  const [index, setIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);

  // Play the audio using ResponsiveVoice API
  const playAudio = (text) => {
    if (window.responsiveVoice) {
      window.responsiveVoice.speak(text, "Arabic Male"); // You can choose different voices like "Arabic Male"
    } else {
      console.error("ResponsiveVoice API is not loaded.");
    }
  };

  const handleNext = () => {
    setIndex((prev) => (prev + 1) % flashcards.length);
    setFlipped(false);
  };

  const handlePrev = () => {
    setIndex((prev) => (prev - 1 + flashcards.length) % flashcards.length);
    setFlipped(false);
  };

  const toggleFlip = () => {
    setFlipped(!flipped);
    // Play the pronunciation when flipping to the back
    if (!flipped) {
      playAudio(flashcards[index].back); // Play pronunciation on the back
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-blue-100 p-6">
      <h1 className="text-3xl font-bold mb-6 text-blue-700">Flashcards</h1>

      {/* Flashcard container with click to flip */}
      <div
        onClick={toggleFlip}
        className={`w-60 h-60 bg-white rounded-lg shadow-lg flex items-center justify-center text-4xl font-bold text-blue-800 cursor-pointer transition-transform duration-300 transform ${
          flipped ? "rotate-y-180" : ""
        }`}
        style={{
          perspective: "1000px", // Add perspective for proper 3D effect
        }}
      >
        {/* Front side of the card */}
        {flipped ? (
          <div>{flashcards[index].back}</div>
        ) : (
          <div>{flashcards[index].front}</div>
        )}
      </div>

      {/* Controls for Previous and Next */}
      <div className="mt-6 flex space-x-4">
        <button
          onClick={handlePrev}
          className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
        >
          Previous
        </button>
        <button
          onClick={handleNext}
          className="px-4 py-2 bg-yellow-400 hover:bg-yellow-500 text-white rounded"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default FlashcardsPage;
